import isBrowser from './isBrowser';
var keys = Object.keys;

function getTransitionProperties() {
  var element = document.createElement('div');
  var style = element.style;
  var vendorMap = {
    O: 'otransitionend',
    Moz: 'transitionend',
    Webkit: 'webkitTransitionEnd',
    ms: 'MSTransitionEnd'
  };
  var vendors = keys(vendorMap);
  var transitionEndEventName;
  var prefix = '';
  vendors.some(function (vendor) {
    if ("".concat(vendor, "TransitionProperty") in style) {
      prefix = "-".concat(vendor.toLowerCase());
      transitionEndEventName = vendorMap[vendor];
      return true;
    }

    return false;
  });

  if (!transitionEndEventName && 'transitionProperty' in style) {
    transitionEndEventName = 'transitionend';
  }

  return {
    transitionEndEventName: transitionEndEventName,
    prefix: prefix
  };
}

var transform;
var prefix;
var transitionEndEventName;
var transitionProperty;
var transitionDuration;
var transitionTiming;
var transitionDelay;

if (isBrowser) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  transitionEndEventName = _getTransitionPropert.transitionEndEventName;
  transform = "".concat(prefix, "transform");
  transitionProperty = "".concat(prefix, "transition-property");
  transitionTiming = "".concat(prefix, "transition-timing-function");
  transitionDelay = "".concat(prefix, "transition-delay");
  transitionDuration = "".concat(prefix, "transition-duration");
}

var transitionProperties = {
  transform: transform,
  transitionProperty: transitionProperty,
  transitionTiming: transitionTiming,
  transitionDelay: transitionDelay,
  transitionDuration: transitionDuration,
  transitionEndEventName: transitionEndEventName
};
export default transitionProperties;
//# sourceMappingURL=transitionProperties.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/pixel/~/@flowio/browser-helpers/dist/esm/transitionProperties.js
// module id = 646
// module chunks = 0 1